import { api } from './client';

/** Conforme CHECK constraint da migration 008 — `Type2` e `CCS2` são os usados no seed. */
export type ConnectorType = 'CCS2' | 'Type2' | 'CHAdeMO' | 'GBT';

export interface ConnectorOut {
  id: string;
  connector_number: number;
  type: ConnectorType | string;
  max_power_kw: string;
  /** Estado vivo (espelha o do charger até o Hub diferenciar por evse_id). */
  state: string | null;
  /** SOC do carro carregando neste cabo (0–100). null = livre, sem dado, ou stale. */
  soc_percent: number | null;
}

export interface PointOut {
  id: string;
  hub_station_id: string;
  name: string;
  address: string;
  latitude: string | null;
  longitude: string | null;
  photo_url: string | null;
  opening_hours: string | null;
  active: boolean;
  capabilities: Record<string, unknown>;
}

export interface ExternalAppRef {
  id: string;
  slug: string;
  name: string;
  /** Path relativo do logo, servido pelo Caddy da VM (decisão #b),
   *  ex: '/static/external-apps/tupi.png'. Pode ser null. */
  icon_url: string | null;
  play_store_url: string | null;
  app_store_url: string | null;
  /** Deep link universal pro carregador inteiro (Tupi, Move). Abre o app já no
   *  carregador; cai na loja se não instalado. */
  deep_link_url: string | null;
  /** Deep link por conector (Spott): { "1": ".../ch/55522-1", "2": "...-2" }.
   *  O PWA escolhe pelo conector selecionado; sem entrada usa deep_link_url e
   *  por fim a loja. */
  connector_deep_links: Record<string, string> | null;
  /** Tarifa vigente do operador NESTE ponto (R$/kWh, string decimal) — fonte
   *  única `operator_tariffs` do admin (específica do ponto > global).
   *  null = sem cadastro; o card da landing /qr oculta o preço. */
  tariff_per_kwh_brl: string | null;
  // Não inclui point_external_id — uso interno do operador (decisão #c).
}

export interface PointDetailOut extends PointOut {
  connectors: ConnectorOut[];
  tariff_per_kwh_brl: string | null;
  tariff_version: number | null;
  /** Apps externos (Tupi, Spott, Move…) cadastrados para este ponto. Vazio
   *  quando nada cadastrado — landing pública oculta o disclosure nesse caso. */
  external_apps: ExternalAppRef[];
}

export const pointsApi = {
  list: () => api.get<PointOut[]>('/points'),
  get: (id: string) => api.get<PointDetailOut>(`/points/${id}`),
  /** Lookup público por hub_station_id — usado pela landing /qr/:stationId. */
  getByHubId: (hubStationId: string) =>
    api.get<PointDetailOut>(`/points/by-hub-id/${encodeURIComponent(hubStationId)}`)
};

/** Display-formata "Type2" → "Type 2". Outros tipos mantêm o valor cru. */
export function formatConnectorType(type: string): string {
  return type === 'Type2' ? 'Type 2' : type;
}
